<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path, addBR } from '@/Shared/helper.js'
import ButtonFavoriteToggle from '@/Shared/Buttons/ButtonFavoriteToggle'
import Icon from '@/Shared/Icons/Logo'

const props = defineProps({
  info: Object,
  name: String,
  url: String,
  icon: String,
})
const addScaledBG = (img) => {
  return 'background:url(' + replaceS3path(img) + ') no-repeat center center;background-size:cover;'
}
</script>
<template>
  <template v-if="!props.name">
    <Link :href="`/stores/afcountry/${props.info.shopSlug}`" class="">
      <div class="store-card">
        <div class="store-card-thumb">
          <div :style="addScaledBG(props.info.shopImg1)">
            <img src="/img/common/placeholder600sq.png" :alt="props.info.productTitle" />
          </div>
        </div>
        <div class="relative">
          <div class="store-card-name" v-html="addBR(stripslashes(info.shopNameJ), 'A&Fカントリー ')" />
          <ButtonFavoriteToggle category="shop" :slug="props.info.shopSlug" :disabled="true" class="store-card-star no-outline" />
        </div>
      </div>
    </Link>
  </template>

  <template v-else>
    <a :href="props.url" target="_blank">
      <div class="store-card">
        <div class="relative store-card-thumb border border-[#999] border-dotted aspect-square flex justify-center items-center">
          <Icon class="w-[60%] h-[60%]" :type="props.icon" />
        </div>
        <div class="relative">
          <div class="store-card-name" v-html="props.name" />
        </div>
      </div>
    </a>
  </template>
</template>
